export default __webpack_public_path__ + "static/media/shinsei.1e80e5cc.png";